import { createApiCall } from "services/api/createApiCall";
import { FiscalizationCertificateInfo } from "services/api/settings/types";
import { filesApi } from "services/api/config";
import { getAccessToken } from "services/auth";
import { showNotification } from "services/api";

export const getFiscalizationCertificateAPI =
  async (): Promise<FiscalizationCertificateInfo> => {
    const response = await createApiCall({
      path: "/v1/settings/fiscalization/certificate",
      method: "GET",
    })();
    return response.data;
  };

export const uploadFiscalizationCertificateAPI = async (
  file: File,
  password: string
): Promise<FiscalizationCertificateInfo> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("password", password);

  const config = {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
      "Content-Type": "multipart/form-data",
    },
  };

  const response = await filesApi.post(
    "/v1/settings/fiscalization/certificate",
    formData,
    config
  );

  showNotification("Certifikat je uspješno učitan", { variant: "success" });
  return response.data;
};

export const deleteFiscalizationCertificateAPI =
  async (): Promise<boolean> => {
    await createApiCall(
      {
        path: "/v1/settings/fiscalization/certificate",
        method: "DELETE",
      },
      {
        getMessage: {
          success: () => "Certifikat je uspješno uklonjen",
        },
      }
    )();
    return true;
  };
